import api from '@/shared/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import DataCacheService from '@/shared/services/DataCacheService';
import { SettingsQueryKey } from './queryKey';
export const useUpdateCompanySettings = () => {
    const intl = useIntl();
    const queryClient = useQueryClient();
    const { mutateAsync, isLoading } = useMutation((model) => api.base.put('/api/settings/Company', model).then(res => res.data), {
        onSuccess: (result) => {
            if (!result)
                return;
            const dataCacheCompany = DataCacheService.getCompanySettings(result.companyId);
            if (dataCacheCompany) {
                const updated = Object.assign(Object.assign({}, result), { sendInvoiceTemplateId: result.templateSendInvoice
                        ? result.templateSendInvoice.id
                        : null });
                Object.assign(dataCacheCompany, updated);
            }
            const { defaultTaskResourceId, taskTimeRegistrationMethod, sendInvoiceUseMailEditor, forceLinkingDocumentsToRelation, useSharedAutomatedCustomerCodeSetup, useSharedAutomatedAccountingNrSetup, } = result;
            const propagated = {
                defaultTaskResourceId,
                taskTimeRegistrationMethod,
                sendInvoiceUseMailEditor,
                forceLinkingDocumentsToRelation,
                useSharedAutomatedCustomerCodeSetup,
                useSharedAutomatedAccountingNrSetup,
            };
            DataCacheService.updateAllCompanies(propagated);
            queryClient.setQueriesData([SettingsQueryKey.CompanySettings], (old) => old ? Object.assign(Object.assign({}, old), propagated) : old);
            queryClient.setQueryData([SettingsQueryKey.CompanySettings, result.companyId], result);
        },
        onError: (apiError) => {
            handleHttpError(intl)(apiError);
        },
    });
    return { updateCompanySettings: mutateAsync, isLoading };
};
